import {
  APPINFO_SUCCESS,
  CREATEAPPLICATION_SUCCESS,
  UPDATEAPPLICATION_SUCCESS,
  FETCHAPPLICATIONS_SUCCESS,
  FETCHAPPLICATION_SUCCESS,
  CHANGEAPPLICATION,
  LOADAPPLICATION,
  FETCHCUSTOMERS_SUCCESS,
  FETCHCUSTOMERINFO_SUCCESS,
  DASHBOARDAPPINFO_SUCCESS,
  DASHBOARDAPPINFOBYTIME_SUCCESS,
  DELETEAPPLICATION_SUCCESS,
  CLEARAPPLICATIONS,
  GENERATEKEY_SUCCESS,
  FETCHSUBKEYS_SUCCESS,
  GENERATESUBKEY_SUCCESS,
  DELETESUBKEY_SUCCESS
} from "../../constants/ActionTypes";

const INIT_STATE = {
  applications: [],
  createdApplication: false,
  selectedApplication: false,
  appInfo: {},
  fetchedApplication: {},
  updatedApplication: {},
  loader: false,
  customers: {},
  customerInfo: {},
  dashboardAppInfo: {},
  dashboardAppInfoByTime: {}
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case APPINFO_SUCCESS: {
      return {
        ...state,
        appInfo: {
          ...state.appInfo,
          [action.applicationId]: action.payload.appInfo
        }
      }
    }

    case DASHBOARDAPPINFO_SUCCESS: {
      return {
        ...state,
        dashboardAppInfo: {
          ...state.dashboardAppInfo,
          [action.applicationId]: action.payload.dashboardAppInfo
        }
      }
    }

    case DASHBOARDAPPINFOBYTIME_SUCCESS: {
      console.log('payload', action.payload);
      return {
        ...state,
        dashboardAppInfoByTime: {
          ...state.dashboardAppInfoByTime,
          [action.applicationId]: action.payload.dashboardAppInfoByTime
        }
      }
    }

    case FETCHAPPLICATIONS_SUCCESS: {
      return {
        ...state,
        applications: action.payload.getAccountApplications || action.payload.getApplicationsWithAccounts
      }
    }

    case FETCHAPPLICATION_SUCCESS: {
      console.log('FETCHAPPLICATION_SUCCESS', action.payload);
      return {
        ...state,
        applications: state.applications.map(a => {
          return (a.applicationId == action.payload.getApplication.applicationId) ?
          action.payload.getApplication : a}),
        fetchedApplication: action.payload.getApplication
      }
    }

    case CLEARAPPLICATIONS: {
      return {
        ...state,
        applications: []
      }
    }

    case FETCHCUSTOMERS_SUCCESS: {
      return {
        ...state,
        customers: {
          ...state.customers,
          [action.applicationId]: action.payload.getCustomers
        }
      }
    }

    case FETCHCUSTOMERINFO_SUCCESS: {
      return {
        ...state,
        customerInfo: {
          ...state.customerInfo,
          [action.customerId]: action.payload.getCustomerInfo
        }
      }
    }

    case CREATEAPPLICATION_SUCCESS: {
      return {
        ...state,
        createdApplication: action.payload
      }
    }

    case UPDATEAPPLICATION_SUCCESS: {
      return {
        ...state,
        updatedApplication: action.payload
      }
    }

    case DELETEAPPLICATION_SUCCESS: {

      return {
        ...state,
        deleted: action.payload,
      }
    }

    case CHANGEAPPLICATION: {
      return {
        ...state,
        selectedApplication: action.payload,
        loader: false
      }
    }

    case LOADAPPLICATION: {
      return {
        ...state,
        selectedApplication: action.payload
      }
    }

    case FETCHSUBKEYS_SUCCESS: {
      return {
        ...state,
        subKeys: action.payload.getSubKeys
      }
    }

    case GENERATEKEY_SUCCESS: {
      console.log('GENERATEKEY_SUCCESS', action);
      return {
        ...state,
        keys: {
          ...state.keys,
          [action.applicationId] : action.payload.generateKey
        }
      }
    }

    case GENERATESUBKEY_SUCCESS: {
      return {
        ...state,
        generatedSubKeys: action.payload.generateSubKey,
        subKeys: [...state.subKeys,...action.payload.generateSubKey]
      }
    }

    case DELETESUBKEY_SUCCESS: {
      return {
        ...state,
        deletedSubKey: action.payload
      }
    }

    default: {
      return {
        ...state,
        fetchedApplication: false,
        generateSubKeys: false,
        deletedSubKey: false
      }
    }
  }
}
